import * as React from "react";

const SvgIcnRead = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width="1em" height="1em" viewBox="0 0 24 24" {...props}>
        <path
            d="M12 17a5 5 0 100-10 5 5 0 000 10zm0 1a6 6 0 110-12 6 6 0 010 12zm-.781-4.38l2.94-3.422a.371.371 0 01.559-.005.483.483 0 01.004.637l-3.354 3.874a.2.2 0 01-.3.002L9.28 12.7a.476.476 0 01-.003-.63.372.372 0 01.558-.003l1.384 1.554z"
            fill="currentColor"
            fillRule="nonzero"
            stroke="none"
            strokeWidth={1}
        />
    </svg>
);

export default SvgIcnRead;
